import { getCompanyPermission } from "../data/repository/company.repo.js";

export const GetCompanyPermissionUseCase = async (companyId) => {
  try {
    const resp = await getCompanyPermission(companyId);

    return resp.data;
  } catch (error) {
    return error.response.data;
  }
};
